import { defineStore } from 'pinia';
import * as horas from '@/services/api/deck/horas.js';
import { useDeckStore } from '@/stores/deckStore.js';

const ESPELHO = 'deck:timer';
const BATIMENTO_MS = 60000;

let relogio = null;
let batimento = null;

/**
 * O cronometro.
 *
 * Store GLOBAL, e nao de modulo, por um motivo concreto: o widget mora no
 * cabecalho, que nao e desmontado na troca de rota. E isso que faz o timer
 * sobreviver a navegacao. O `setInterval` nunca mora numa pagina.
 *
 * Tres decisoes que parecem detalhe e nao sao:
 *
 * **1. A verdade esta no SERVIDOR.** O `localStorage` e espelho, so para o
 * primeiro quadro depois de um F5 nao piscar. Quem manda e o `GET /timer`.
 *
 * **2. O decorrido e CALCULADO, nao incrementado.** Navegador estrangula
 * `setInterval` de aba em segundo plano para uma vez por minuto; um contador
 * incrementado atrasaria sem ninguem perceber.
 *
 * **3. O desvio de relogio entra na conta.** Vem do `server_time` do `/me`.
 * Sem ele, um notebook quatro minutos adiantado mostra timer negativo -- e
 * quem estava certo era o servidor.
 */
export const useTimerStore = defineStore('timer', {
    state: () => ({
        timer: lerEspelho(),
        segundos: 0,
        abandonado: null,
        carregando: false,
    }),

    getters: {
        rodando: (state) => !!state.timer,
        cardAtual: (state) => state.timer?.issue ?? null,
    },

    actions: {
        async sincronizar() {
            this.carregando = true;

            try {
                const resposta = await horas.timer();

                this.aplicar(resposta.data);

                if (resposta.server_time) {
                    useDeckStore().desvioDoRelogio = Date.now() - Date.parse(resposta.server_time);
                }
            } finally {
                this.carregando = false;
            }
        },

        async iniciar(issueKey, nota = null) {
            const resposta = await horas.iniciarTimer(issueKey, nota);

            this.aplicar(resposta.data);

            /*
             * Iniciar um segundo cronometro PARA o primeiro e grava o tempo
             * dele. A tela avisa ("Pausado: DECK-42, 1h12") -- o tempo nao
             * pode sumir sem uma palavra.
             */
            return resposta.stopped ?? null;
        },

        async parar(extras = {}) {
            const resposta = await horas.pararTimer(extras);

            this.aplicar(null);

            return resposta.data;
        },

        /** Descarta sem apontar. Para quem clicou no card errado. */
        async descartar() {
            await horas.descartarTimer();
            this.aplicar(null);
        },

        aplicar(timer) {
            this.timer = timer ?? null;
            this.recalcular();
            gravarEspelho(this.timer);
            this.reagendar();
        },

        recalcular() {
            if (!this.timer) {
                this.segundos = 0;

                return;
            }

            const inicio = Date.parse(this.timer.started_at);
            const agora = useDeckStore().agora();

            this.segundos = Math.max(0, Math.floor((agora - inicio) / 1000));
        },

        /**
         * Liga o relogio da tela e o batimento do servidor.
         *
         * O batimento nao e enfeite: sem ele, o relogio do servidor fecha o
         * apontamento em `now()` quando a aba morre, e a sexta a noite vira
         * 62 horas na folha de alguem. Com ele, o corte acontece no ultimo
         * sinal conhecido.
         */
        reagendar() {
            clearInterval(relogio);
            clearInterval(batimento);

            if (!this.timer) {
                return;
            }

            relogio = setInterval(() => this.recalcular(), 1000);
            batimento = setInterval(() => horas.batimentoTimer().catch(() => {}), BATIMENTO_MS);
        },

        /**
         * O `pagehide` e o unico evento confiavel para "a aba esta indo
         * embora" -- `beforeunload` nao serve para chamada de rede, e o
         * navegador cancela um `fetch` disparado ali. `sendBeacon` e feito
         * exatamente para isto.
         */
        instalarBeacon() {
            if (typeof window === 'undefined') {
                return;
            }

            window.addEventListener('pagehide', () => {
                if (!this.timer) {
                    return;
                }

                const base = window.appConfig?.URL_API_BASE_DECK || '';

                try {
                    navigator.sendBeacon?.(`${base}/api/timer/heartbeat`);
                } catch {
                    // Beacon e melhor esforco por definicao. O corte pelo
                    // relogio cobre o resto.
                }
            });
        },

        parar_relogios() {
            clearInterval(relogio);
            clearInterval(batimento);
        },
    },
});

function gravarEspelho(timer) {
    try {
        if (timer) {
            localStorage.setItem(ESPELHO, JSON.stringify(timer));
        } else {
            localStorage.removeItem(ESPELHO);
        }
    } catch {
        // Espelho e conveniencia: sem ele, o primeiro quadro depois do F5
        // pisca. Nao e motivo para quebrar nada.
    }
}

function lerEspelho() {
    try {
        return JSON.parse(localStorage.getItem(ESPELHO) || 'null');
    } catch {
        return null;
    }
}
